import React from 'react';
import PropTypes from 'prop-types';

const Loft = ({ className, checked }) => (
    <svg
        width="56px"
        height="56px"
        viewBox="0 0 56 56"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className} ${checked ? 'path__fill__checked' : 'path__fill'}`}
    >
        <title>Loft / Atelier</title>
        <desc>Created with Sketch.</desc>
        <g id="assets" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.6">
            <g id="Loft" fill="#393939">
                <g id="Page-1" transform="translate(3.000000, 10.000000)">
                    <path
                        d="M12,27.0009 L24,27.0009 L24,21.0009 L12,21.0009 L12,27.0009 Z M25,19.0009 L11,19.0009 C10.448,19.0009 10,19.4489 10,20.0009 L10,28.0009 C10,28.5539 10.448,29.0009 11,29.0009 L25,29.0009 C25.552,29.0009 26,28.5539 26,28.0009 L26,20.0009 C26,19.4489 25.552,19.0009 25,19.0009 L25,19.0009 Z"
                        id="Fill-1"
                    />
                    <path
                        d="M40,33.0009 L40,20.0009 C40,19.4489 39.553,19.0009 39,19.0009 L31,19.0009 C30.447,19.0009 30,19.4489 30,20.0009 L30,33.0009 L6,33.0009 L6,15.7819 L44,6.2819 L44,33.0009 L40,33.0009 Z M32,33.0009 L38,33.0009 L38,21.0009 L32,21.0009 L32,33.0009 Z M49,33.0009 L46,33.0009 L46,5.0009 C46,4.6929 45.858,4.4019 45.615,4.2129 C45.372,4.0229 45.056,3.9559 44.758,4.0309 L4.757,14.0309 C4.312,14.1419 4,14.5419 4,15.0009 L4,33.0009 L1,33.0009 C0.448,33.0009 0,33.4479 0,34.0009 C0,34.5539 0.448,35.0009 1,35.0009 L5,35.0009 L31,35.0009 L39,35.0009 L45,35.0009 L49,35.0009 C49.553,35.0009 50,34.5539 50,34.0009 C50,33.4479 49.553,33.0009 49,33.0009 L49,33.0009 Z"
                        id="Fill-3"
                    />
                    <path
                        d="M4.999,12.0009 C5.08,12.0009 5.161,11.9919 5.243,11.9709 L45.242,1.9709 C45.778,1.8369 46.104,1.2939 45.97,0.7579 C45.836,0.2229 45.293,-0.1051 44.758,0.0309 L4.757,10.0309 C4.222,10.1649 3.896,10.7079 4.03,11.2439 C4.144,11.6979 4.551,12.0009 4.999,12.0009"
                        id="Fill-4"
                    />
                </g>
            </g>
        </g>
    </svg>
);

Loft.displayName = 'Loft';

Loft.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
};

/**
 * Loft Functional Component.
 */
export default Loft;
